module.exports = __webpack_public_path__ + "static/media/thermometer-three-quarters.624a46df.svg";